module.exports = __webpack_public_path__ + "img/2M.ea6fddb6.png";